import SettingModal from "./SingleWeighSettingsModal";

export default SettingModal;
